import Sidebar from "../../sidebar";
import {
  Formik,
  Form,
  Field,
  ErrorMessage,
  getIn,
  FormikHelpers,
} from "formik";
import * as Yup from "yup";
import Toggle from "react-toggle";
import "react-toggle/style.css";
import FormInput from "../../../../components/FormInput";
import { useEffect, useState } from "react";
import {
  addBannerImage,
  getBannerImage,
  updateBannerImage,
} from "./form-section.service";
import toast from "react-hot-toast";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { validationSchema } from "./validation";

export default function FormSection({ isEdit }: { isEdit: boolean }) {
  const [banner, setBanner] = useState<any>();
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();
  const param = useParams();

  const handleSubmit = (values: any, actions: FormikHelpers<any>) => {
    let formData = new FormData();
    formData.append("title", values.title);
    formData.append("buttonText", values.buttonText);
    if (values.image.file) {
      formData.append("image", values.image.file);
    }

    if (isEdit) {
      updateBannerImage(param.id as string, formData)
        .then((response) => {
          toast.success("Banner Image updated successfully.");
          navigate("/admin/banner-images");
        })
        .catch((error) => {
          toast.error(error.response.data.message);
        })
        .finally(() => {
          actions.setSubmitting(false);
        });
    } else {
      addBannerImage(formData)
        .then((response) => {
          toast.success("Banner Image added successfully.");
          navigate("/admin/banner-images");
        })
        .catch((error) => {
          toast.error(error.response.data.message);
        })
        .finally(() => {
          actions.setSubmitting(false);
        });
    }
  };

  const createImageURL = (key: string) => {
    return `https://d1gdand68muq63.cloudfront.net/banners/96/${key}`;
  };

  useEffect(() => {
    if (isEdit) {
      console.log("Param:", param.id);
      getBannerImage(param.id as string).then((response) => {
        const url = createImageURL(response.data.image.key);

        response.data.image = {
          url: url,
          file: null,
        };
        setBanner(response.data);
        setLoading(false);
      });
    } else {
      setLoading(false);
    }
  }, []);

  return (
    <section className="ec-page-content ec-vendor-dashboard section-space-p">
      <div className="container">
        <div className="row">
          <Sidebar />
          <div className="ec-shop-rightside col-lg-9 col-md-12">
            <div className="ec-vendor-dashboard-card space-bottom-30">
              <div className="ec-vendor-card-header">
                <h5>Add banner Image</h5>
              </div>
              <div className="ec-vendor-card-body">
                {loading ? (
                  "Loading..."
                ) : (
                  <Formik
                    validationSchema={validationSchema}
                    initialValues={{
                      title: banner ? banner.title : "",
                      buttonText: banner ? banner.buttonText : "",
                      image: banner ? banner.image : "",
                    }}
                    onSubmit={handleSubmit}
                  >
                    {({
                      handleChange,
                      handleBlur,
                      errors,
                      values,
                      touched,
                      handleSubmit,
                      setFieldValue,
                    }) => (
                      <Form className="add_product_form">
                        <div className="row">
                          <div className="col-lg-12">
                            <div className="image-input">
                              <img
                                src={values.image?.url}
                                className="image-preview"
                                alt="img"
                              />
                              <input
                                type="file"
                                accept="image/*"
                                id="imageInput"
                                onChange={
                                  (e: any) => {
                                    let formData = new FormData();
                                    setFieldValue("image", {
                                      url: URL.createObjectURL(
                                        e.target.files[0]
                                      ),
                                      file: e.target.files[0],
                                    });
                                    // formData.append("files", e.target.files[0]);
                                    // formData.append("topstuff", event.target.topstuff.value);
                                    // formData.append("bottomstuff", event.target.bottomstuff.value);

                                    // dispatch(
                                    //   handleUploadFile(e.target.files)
                                    // ).then((response) => {
                                    //   console.log(response);
                                    //   // console.log(response.locationArray[0]);
                                    //   // setImage(response.locationArray[0]);
                                    //   setFieldValue("image", response);
                                    // });
                                  }
                                  // this.setState({
                                  //   imageFile: this.upload.files[0],
                                  //   imageName: this.upload.files[0].name,
                                  // })
                                }
                              />
                              <label
                                htmlFor="imageInput"
                                className="image-button"
                              >
                                <i className="fa fa-image"></i>Choose image
                              </label>
                              <div className="invalid-feedback d-block text-danger">
                                {getIn(errors, "image")}
                              </div>
                            </div>
                          </div>

                          <div className="col-lg-6">
                            <FormInput
                              label="Title"
                              placeholder="Title"
                              name="title"
                              type="text"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.title}
                              error={getIn(errors, "title")}
                              touched={getIn(touched, "title")}
                              autoFocus
                              isRequired={true}
                              className={""}
                            />
                          </div>

                          <div className="col-lg-6">
                            <FormInput
                              label="Button Text"
                              placeholder="Button Text"
                              name="buttonText"
                              type="text"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.buttonText}
                              // error={errors.buttonText}
                              touched={getIn(touched, "buttonText")}
                              isRequired={false}
                              error={getIn(errors, "buttonText")}
                              className={""}
                            />
                          </div>

                          <div className="col-lg-12">
                            <div className="btn_right_table">
                              <button
                                className="btn btn-primary mr-1"
                                type="submit"
                              >
                                {isEdit ? "Save Banner" : "Add Banner"}
                              </button>
                            </div>
                          </div>
                        </div>
                      </Form>
                    )}
                  </Formik>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
